module.exports = __webpack_public_path__ + "img/img12.d5463a33.png";